import { actionTypes } from "./storeTypes";

export const init_local = {
  relativeperformance: { rawdata: [] },
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_RELATIVEPERFORMANCE: {
      return {
        ...state,
        relativeperformance: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
